import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import store from './store'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: { path: '/:region', params: {region: store.state.Region.region} }
    },
    {
      path: '/:region',
      component: Home
    },
    {
      path: '/:region/examine-your-eating',
      name: 'evaluate-your-plate',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/EvaluateYourPlate.vue')
    },
    {
      path: '/:region/evaluate-your-plate/diet-breakdown',
      name: 'dietbreakdown',
      component: () => import('./views/DietBreakdown')
    },
    {
      path: '/:region/map-your-meal',
      // name: 'map-your-meal',
      component: () => import('./views/MapYourMeal.vue'),
      children: [
        {
          path: '',
          name: 'map-your-meal',
          component: () => import(/* webpackChunkName: "mealbreakdown" */'./components/MealList')
        },
        {
          path: ':mealbreakdown',
          name: 'breakdown',
          component: () => import(/* webpackChunkName: "mealbreakdown" */'./views/MealBreakdown')
        }
      ]
    },
    // {
    //   path: '/:region/map-your-meal/:mealbreakdown',
    //   name: 'breakdown',
    //   component: () => import('./views/MealBreakdown')
    // }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
